<template>
  <div :class="['calendar',{'SingularExtend': SingularExtend}]">
    <div class="top"></div>
    <!-- 左侧资源预览 -->
    <div class="calendarLeft">
      <page-left-resource
        :bookmark="bookmark"
        @currentSelectData="currentSelectData"
        @editTemplate="editTemplate"></page-left-resource>
    </div>
    <!-- 中间时间表显示 -->
    <div
      class="calendar_box f_left"
      v-show="IsShowTemplate == 0">
      <div class="events_and_play f_left clearfix">
        <center-box
          :fixedDevice="selectR"
          :dynamicDevice="selectSource">
        </center-box>
      </div>
    </div>
    <!-- 右侧功能操作 -->
    <div
      class="preview f_left"
      v-show="IsShowTemplate == 0">
      <right-box></right-box>
    </div>
    <!-- program模板 -->
    <div
      class="ProgramTemplateEdit"
      v-if="IsShowTemplate == 2">
      <template-page-right @closeProgramTemplate="CancelTemplate"></template-page-right>
    </div>
  </div>
</template>
<script>
import centerBox from './centerBox'
import rightBox from './rightBox'
import Outil from '@/assets/js/utils.js'
import PageLeftResource from '@/components/common/PageLeftResource.vue'
import TemplatePageRight from '@/views/ProgramTemplate/TemplatePageRight.vue'
import Bus from '@/assets/js/vueBus.js'

export default {
  components: {
    centerBox,
    rightBox,
    // calendarLeft,
    PageLeftResource,
    TemplatePageRight
  },
  props: ['bookmark'],
  data () {
    return {
      selectR: {}, // 保留
      selectSource: {}, // 保留
      // 是否显示模板
      IsShowTemplate: 0,
      // 展开显示singular
      SingularExtend: false
    }
  },
  created () {
    const ProgramRMessage = Outil.getProgramReceiver()
    if (ProgramRMessage) {
      this.currentSelectData(ProgramRMessage)
    }
  },
  mounted () {
    Bus.$on('IsSelectSingular', (data) => {
      this.SingularExtend = !!data.select
    })
  },
  methods: {
    // 取消编辑模板
    CancelTemplate () {
      this.IsShowTemplate = 0
    },
    // 编辑模板
    editTemplate (data) {
      if (data.name == 'programTemplate') {
        if (data.status) this.IsShowTemplate = 2
        if (!data.status && this.IsShowTemplate == 2) this.IsShowTemplate = 0
        if (this.IsShowTemplate == 2) Bus.$emit('programTemplateEdit')
      }
    },
    // 列表变动 （保留）
    listChange () {
      this.$nextTick(() => {
        // this.dragToCreateEvent();
      })
    },
    // 选择源  (保留)
    chooseSource (item) {
      this.selectSource = JSON.parse(JSON.stringify(item))
    },
    // 选择R （保留）
    currentSelectData (item) {
      this.selectR = JSON.parse(JSON.stringify(item))
    }

  }
}
</script>
<style lang='less' scoped>
.calendar {
  min-height: 850px;
  height: 100%;
  background: #444;
  .ProgramTemplateEdit{
    float: right;
    width: calc(100% - 600px);
    height: 100%;
  }
  .calendarLeft {
    width: 600px;
    height: 100%;
    float: left;
  }
  .calendar_box {
    width: calc(100% - 1200px);
    height: 100%;
    background: #444;
    .events_and_play{
        width: 100%;
        height: 100%;
    }
  }
  .preview {
    width: 600px;
    height: 100%;
  }
}

@media (max-width: 1680px) {
  .calendar {
    .calendarLeft {
      width: 450px;
    }
    .calendar_box {
      width: calc(100% - 930px);
    }
    .preview {
      width: 480px;
    }
    .ProgramTemplateEdit{
      width: calc(100% - 450px);
    }
  }
}

@media (max-width: 1480px) {
  .calendar {
    .calendarLeft {
      width: 360px;
    }
    .calendar_box {
      width: calc(100% - 750px);
    }
    .preview {
      width: 390px;
    }
    .ProgramTemplateEdit{
      width: calc(100% - 360px);
    }
  }
}
@media (max-width: 1330px) {
  .calendar {
    .calendarLeft {
      width: 324px;
    }
    .calendar_box {
      width: calc(100% - 688px);
    }
    .preview {
      width: 364px;
    }
    .ProgramTemplateEdit{
      width: calc(100% - 324px);
    }
  }
}
@media (max-width: 1280px) {
  .calendar {
    width: 1280px;
    .calendar_box {
      width: 591px;
    }
  }
}

@keyframes antline {
  0% {
    background-position: 0px 0px;
  }
  50% {
    background-position: 0px 5px;
  }
  100% {
    background-position: 0px 10px;
  }
}
</style>
